@if (user ) {
  <div class="wrapper has-padding">
    <h1 class="bofa--heading is-4">Vendor registration</h1>
    <form [formGroup]="accountGroup" (ngSubmit)="onSubmit()">
      @if (showError) {
        <div class="global-red bottom-space">
          {{ user.errorMessage }}
        </div>
      }
      <p class="global-red">All fields are required. Required fields are followed by <abbr title="required">*</abbr>.</p>
      <mat-form-field class="flex-width width-400" hideRequiredMarker>
        <mat-label><abbr title="required">* </abbr>Username</mat-label>
        <input matInput value="{{user.username}}" disabled>
        <mat-error>Please enter Username</mat-error>
      </mat-form-field>
      <div formGroupName="passwordGroup">
        <div class="is-taller">
          <mat-form-field class="divider zoom-padding-right width-200">
            <mat-label>Password</mat-label>
            <input matInput formControlName="password" (focus)="showHint($event)" (blur)="showHint($event)"
              [type]="hide ? 'password' : 'text'" maxlength="20" required autocomplete="off">
            <mat-hint>
              <div class="bofa--skiplink">
                <!-- Hidden divs are for screen readers -->
                <span>Rules:</span>
                <ul>
                  <li>Minimum 8 characters long, Maximum of 20</li>
                  <li>No special characters allowed: &, $, %, etc.</li>
                  <li>At least one letter (a.k.a. alphabetic character)</li>
                  <li>At least one number (a.k.a. numeric character)</li>
                  <li>Cannot be your username</li>
                </ul>
              </div>
            </mat-hint>
            <mat-error>
              Please enter password
              <div class="bofa--skiplink">
                <ul>
                  <li>Rules:</li>
                  <li>Minimum 8 characters long, Maximum of 20</li>
                  <li>No special characters allowed: &, $, %, etc.</li>
                  <li>At least one letter (a.k.a. alphabetic character)</li>
                  <li>At least one number (a.k.a. numeric character)</li>
                  <li>Cannot be your username</li>
                </ul>
                @if (!(password.value && (reenterPassword.value==password.value) && checkSpecialCharacters(password.value) &&
                  checkAlphaCharacter(password.value) && checkNumeric(password.value) && (password.value != user.username))) {
                  <div>
                    Currently password does not match requirements
                  </div>
                }
              </div>
            </mat-error>
          </mat-form-field>
          <button type="button" class="bofa--button secondary outlined zoom-width flex-space" (click)="hide = !hide"
          [attr.aria-label]="'Show or Hide password'" [attr.aria-pressed]="hide">{{hide ? 'Show' : 'Hide'}}</button>
          <button type="button" class="bofa--button secondary" (click)="generatePassword()">Generate new strong
          password</button>
        </div>
        @if (showPasswordHint) {
          <div
            class="has-background cool-gray-5 has-padding flex-rules flex-text max-zoom min-font width-400">
            <span class="bottom-space">Rules</span>
            <ul class="list-reset">
              <li>
                <input formControlName="check1" type="checkbox"
                  [checked]="password.value && (password.value.length >= 8 && password.value.length <= 20)" />Minimum 8 characters long, Maximum of 20
                </li>
                <li>
                  <input formControlName="check2" type="checkbox"
                    [checked]="password.value && checkSpecialCharacters(password.value)" />No special
                    characters allowed: &, $, %, etc.
                  </li>
                  <li>
                    <input formControlName="check3" type="checkbox"
                      [checked]="password.value && checkAlphaCharacter(password.value)" />At least one letter
                      (a.k.a. alphabetic character)
                    </li>
                    <li>
                      <input formControlName="check4" type="checkbox"
                        [checked]="password.value && checkNumeric(password.value)" />At least one number (a.k.a.
                        numeric character)
                      </li>
                      <li>
                        <input formControlName="check5" type="checkbox"
                          [checked]="password.value && (password.value != user.username)" />Cannot be your username
                        </li>
                      </ul>
                    </div>
                  }
                  <div class="bottom-space padding-top">
                    <mat-form-field class="width-200">
                      <mat-label>Re-enter password</mat-label>
                      <input matInput formControlName="reenterPassword" (focus)="showHintTwo($event)" (blur)="showHintTwo($event)"
                        type="password" maxlength="20" required>
                      <mat-hint>
                        <div class="bofa--skiplink">
                          Rules: must match previously entered password
                        </div>
                      </mat-hint>
                      @if (reenterPassword.hasError('required') || reenterPassword.hasError('noMatch') ) {
                        <mat-error>
                          Please re-enter password
                          <div class="bofa--skiplink">
                            Rules: must match previously entered password.
                            @if (!(password.value && (reenterPassword.value==password.value))) {
                              <div>
                                Currently passwords do not match
                              </div>
                            }
                          </div>
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  @if (showReEnterPasswordHint) {
                    <div
                      class="flex-rules flex-text has-background cool-gray-5 has-padding max-zoom min-font width-400">
                      <span class="bottom-space">Rules</span>
                      <ul class="list-reset">
                        <li>
                          <input type="checkbox" formControlName="check6"
                            [checked]="password.value && (reenterPassword.value==password.value)" />Must match
                            previously entered password
                          </li>
                        </ul>
                      </div>
                    }
                  </div>
                  <div class="max-width width-735">
                    <h2 class="bofa--heading is-6 padding-top">Select and answer five challenge questions</h2>
                    <p class="has-no-padding small-font">If you forget your password, you will be asked to provide
                    the answers to all five challenge questions before you are able to reset your password.</p>
                    <div class="bofa--alert has-background cool-gray-5 has-padding is-stacked width-650">
                      <ul class="has-no-padding has-no-margin list-sec">
                        <li>
                          <span class="padd-10">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="img-size" aria-label="information icon">
                              <g data-name="ICON OUTLINES">
                                <path fill="#012169" d="M12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Zm0,19a9,9,0,1,1,9-9A9.01,9.01,0,0,1,12,21Z" transform="translate(-2 -2)"/>
                                <path fill="#012169" d="M11.992,6.848a.632.632,0,0,0-.617.64.625.625,0,0,0,1.25,0A.635.635,0,0,0,11.992,6.848Z" transform="translate(-2 -2)"/>
                              <rect fill="#012169" x="9.5" y="7" width="1" height="8"/></g>
                            </svg>
                          </span>Different questions. Different answers</li>
                          <li class="padd-40">Note: You cannot select the same question twice or provide the same answer for
                          different questions</li>
                        </ul>
                      </div>
                      <div formGroupName='securityQuestions'>
                        <mat-form-field class="secure-questions zoom-questions zoom-questions-width">
                          <mat-label>Question 1</mat-label>
                          <mat-select formControlName="question1" required>
                            <mat-option>Select</mat-option>
                            @for (question of user.questionLookup | keyvalue : valueAscOrder; track question) {
                              <mat-option [value]="question">
                                {{question.value}}
                              </mat-option>
                            }
                          </mat-select>
                          @if (question1.hasError('required') || question1.hasError('duplicate') ) {
                            <mat-error>Please select
                            Question 1 and ensure you have not selected a duplicate question</mat-error>
                          }
                        </mat-form-field>
                        <mat-form-field class="question-space secure-questions zoom-questions-width">
                          <mat-label>Answer to question 1</mat-label>
                          <input matInput type="password" formControlName="answer1" required autocomplete="off">
                          @if (answer1.hasError('required') || answer1.hasError('duplicate')) {
                            <mat-error>Please enter answer 1 and
                              ensure you have not
                            duplicated an answer from a previous question</mat-error>
                          }
                        </mat-form-field>
                        <mat-form-field class="secure-questions zoom-questions zoom-questions-width">
                          <mat-label>Question 2</mat-label>
                          <mat-select formControlName="question2" required>
                            <mat-option>Select</mat-option>
                            @for (question of user.questionLookup | keyvalue : valueAscOrder; track question) {
                              <mat-option [value]="question">
                                {{question.value}}
                              </mat-option>
                            }
                          </mat-select>
                          @if (question2.hasError('required') || question2.hasError('duplicate') ) {
                            <mat-error>Please select
                            Question 2 and ensure you have not selected a duplicate question</mat-error>
                          }
                        </mat-form-field>
                        <mat-form-field class="question-space secure-questions zoom-questions-width">
                          <mat-label>Answer to question 2</mat-label>
                          <input matInput type="password" formControlName="answer2" required autocomplete="off">
                          @if (answer2.hasError('required') || answer2.hasError('duplicate')) {
                            <mat-error>Please enter answer
                            2 and ensure you have not duplicated an answer from a previous question</mat-error>
                          }
                        </mat-form-field>
                        <mat-form-field class="secure-questions zoom-questions zoom-questions-width">
                          <mat-label>Question 3</mat-label>
                          <mat-select formControlName="question3" required>
                            <mat-option>Select</mat-option>
                            @for (question of user.questionLookup | keyvalue  : valueAscOrder; track question) {
                              <mat-option [value]="question">
                                {{question.value}}
                              </mat-option>
                            }
                          </mat-select>
                          @if (question3.hasError('required') || question3.hasError('duplicate')) {
                            <mat-error>Please
                            select Question 3 and ensure you have not selected a duplicate question</mat-error>
                          }
                        </mat-form-field>
                        <mat-form-field class="question-space secure-questions zoom-questions-width">
                          <mat-label>Answer to question 3</mat-label>
                          <input matInput type="password" formControlName="answer3" required autocomplete="off">
                          @if (answer3.hasError('required') || answer3.hasError('duplicate')) {
                            <mat-error>Please enter answer
                            3 and ensure you have not duplicated an answer from a previous question</mat-error>
                          }
                        </mat-form-field>
                        <mat-form-field class="secure-questions zoom-questions zoom-questions-width">
                          <mat-label>Question 4</mat-label>
                          <mat-select formControlName="question4" required>
                            <mat-option>Select</mat-option>
                            @for (question of user.questionLookup | keyvalue : valueAscOrder; track question) {
                              <mat-option [value]="question">
                                {{question.value}}
                              </mat-option>
                            }
                          </mat-select>
                          @if (question4.hasError('required') || question4.hasError('duplicate')) {
                            <mat-error>Please select
                            Question 4 and ensure you have not selected a duplicate question</mat-error>
                          }
                        </mat-form-field>
                        <mat-form-field class="question-space secure-questions zoom-questions-width">
                          <mat-label>Answer to question 4</mat-label>
                          <input matInput type="password" formControlName="answer4" required autocomplete="off">
                          @if (answer4.hasError('required') || answer4.hasError('duplicate')) {
                            <mat-error>Please enter answer
                            4 and ensure you have not duplicated an answer from a previous question</mat-error>
                          }
                        </mat-form-field>
                        <mat-form-field class="secure-questions zoom-questions zoom-questions-width">
                          <mat-label>Question 5</mat-label>
                          <mat-select formControlName="question5" required>
                            <mat-option>Select</mat-option>
                            @for (question of user.questionLookup | keyvalue : valueAscOrder; track question) {
                              <mat-option [value]="question">
                                {{question.value}}
                              </mat-option>
                            }
                          </mat-select>
                          @if (question5.hasError('required') || question5.hasError('duplicate')) {
                            <mat-error>Please select
                            Question 5 and ensure you have not selected a duplicate question</mat-error>
                          }
                        </mat-form-field>
                        <mat-form-field class="question-space secure-questions zoom-questions-width">
                          <mat-label>Answer to question 5</mat-label>
                          <input matInput type="password" formControlName="answer5" required autocomplete="off">
                          @if (answer5.hasError('required') || answer5.hasError('duplicate')) {
                            <mat-error>Please enter answer
                            5 and ensure you have not duplicated an answer from a previous question</mat-error>
                          }
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="bofa--action_bar is-taller mobile-flex">
                      <button (submit)="onSubmit()" [disabled]="!accountGroup.valid" class="bofa--button primary large">Create my
                      profile</button>
                      <button type="button" class="bofa--button primary outlined" (click)="accountGroup.reset()">Clear all
                      fields</button>
                    </div>
                    @if (!accountGroup.valid) {
                      <div class="bofa--skiplink" tabindex="0" (focus)="invalidAlert()" (blur)="clearAlert()">
                        @if (readMessage) {
                          <span aria-label="Form is not complete, create my profile button disabled" aria-live="polite" role="status"
                          >Form is not complete, create my profile button disabled</span>
                        }
                      </div>
                    }
                  </form>
                </div>
              } @else {
                <p>Loading Applicant User...</p>
              }

